import { useAdaptFileUrl } from '@unifyapps/network/hooks/useAdaptFileUrl';

// Cache map for stable component instances
const imageIconCache = new Map<string, React.ComponentType<React.SVGProps<SVGSVGElement>>>();

function createImageIcon(iconName: string) {
  return function ImageIcon(props: React.SVGProps<SVGSVGElement>) {
    const adaptFileUrl = useAdaptFileUrl();

    return (
      // @ts-expect-error -- this is a workaround to allow the svg to be rendered as an image
      <img alt={iconName} src={adaptFileUrl(iconName)} {...props} />
    );
  };
}

export default function getImageIcon({ iconName }: { iconName: string }) {
  if (!imageIconCache.has(iconName)) {
    imageIconCache.set(iconName, createImageIcon(iconName));
  }
  return imageIconCache.get(iconName);
}
